import { render, staticRenderFns } from "./AddCameraModal3.vue?vue&type=template&id=3572d8d9&scoped=true&"
import script from "./AddCameraModal3.vue?vue&type=script&lang=js&"
export * from "./AddCameraModal3.vue?vue&type=script&lang=js&"
import style0 from "./AddCameraModal3.vue?vue&type=style&index=0&id=3572d8d9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3572d8d9",
  null
  
)

export default component.exports